<template>
  <div v-if="showSelector" class="hide-amounts-selector">
    <v-btn small text class="px-0" @click="toogle">
      <v-icon v-if="!hideAmounts" size="23" :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
        mdi-eye-outline
      </v-icon>
      <v-icon v-else size="23" :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
        mdi-eye-closed
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    showSelector: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(['hideAmounts']),
  },
  methods: {
    ...mapMutations({
      setHideAmounts: 'SET_HIDE_AMOUNTS',
    }),
    toogle() {
      this.setHideAmounts(!this.hideAmounts)
    },
  },
}
</script>
